import { api_get, api_post } from "./utils"

const ProjectAPI = {
    load: _loadProject,
    list: _loadProjectList,
    listByIdentity: _loadProjectListByIdentity,
    listByDedicatedIdentity: _loadProjectListByDedicatedIdentity,
    create: _createProject,
    createByAssistant: _createProjectByAssistant,
    update: _updateProject,
    createCollab: _createCollab,
    createCollabByDedicated: _createCollabByDedicated,
    fetchCollabsWith: _fetchCollabsWith,
    getCollabsByKeyList: _getCollabsByKeyList,
    getCollabs: _getCollabs,
    getCollab: _getCollab,
    collabInviteMutual: _collabInviteMutual,
    collabInviteDedicated: _collabInviteDedicated,
    collabInviteSupport: _collabInviteSupport,
    collabDedicatedInviteDayOne: _collabDedicatedInviteDayOne,
    collabInviteCreate: _collabInviteCreate,
    collabInviteList: _collabInviteList,
    collabInviteAvailableList: _collabInviteAvailableList,
    collabInviteMutualList: _collabInviteMutualList,
    collabInviteAcceptedList: _collabInviteAcceptedList,
    collabInviteGet: _collabInviteGet,
    collabAcceptInvite: _collabAcceptInvite,
    collabWithdrawInvite: _collabWithdrawInvite,

};


async function _loadProject(key: string) {

    if (!key) {
        return null;
    }
    return api_get("/project/" + key).then((res) => {
        if (!res.ok) {
            return null;
        }
        else {
            return res.json();
        }
    });
}



async function _loadProjectList(cursor: string) {
    let url = '/project/';
    if (cursor) { url += '?cursor=' + cursor; }
    return api_get(url).then(async (res) => {
        if (!res.ok) {
            return await res.json();
        }
        else {
            return await res.json();
        }
    });
}

async function _loadProjectListByIdentity(identityKey: string, cursor: string) {
    let url = '/project/by-identity?identity=' + identityKey;
    if (cursor) { url += '&cursor=' + cursor; }
    return api_get(url).then(async (res) => {
        if (!res.ok) {
            return await res.json();
        }
        else {
            return await res.json();
        }
    });
}




async function _loadProjectListByDedicatedIdentity
(assistantIdentityKey="", identityKey="", cursor="") {
    let url = '/project/by-dedicated-identity?assistant_identity=' + assistantIdentityKey +
            '&identity=' + identityKey;
    if (cursor) { url += '&cursor=' + cursor; }
    return api_get(url).then(async (res) => {
        if (!res.ok) {
            return await res.json();
        }
        else {
            return await res.json();
        }
    });
}



async function _createProject(title: string, cadence: string, identity: string, visibility: string) {
    return api_post('/project/create',
        {
            "title": title,
            "cadence": cadence,
            "identity": identity,
            "visibility": visibility
        })
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
            else {
                throw await res.json();
            }
        });
}


async function _createProjectByAssistant(workKey: string, title: string, cadence: string, identity: string) {
    return api_post('/project/create-by-dedicated',
        {
            "identity": workKey,
            "title": title,
            "cadence": cadence,
            "client_identity": identity,
        })
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
            else {
                throw await res.json();
            }
        });
}





async function _updateProject(key: string, title: string, cadence: string, identity: string, visibility: string) {
    return api_post('/project/update',
        {
            "title": title,
            "key": key,
            "cadence": cadence,
            "identity": identity,
            "visibility": visibility
        })
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
        });
}




async function _createCollabByDedicated(workKey: string, project: string, identity: string, title: string, description: string) {
    return api_post('/collab/create-by-dedicated',
        {"identity": workKey,
            "project": project,
            "title": title,
            "client_identity": identity,
            "description": description,
        })
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
            else {
                throw await res.json();
            }
        });
}


async function _createCollab(project: string, identity: string, title: string, description: string, variant: string) {
    return api_post('/collab/create',
        {"project": project,
            "title": title,
            "identity": identity,
            "description": description,
            "variant": variant
        })
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
            else {
                throw await res.json();
            }
        });
}


async function _getCollabs(identityUuid: string, projectUuid: string, cursor = "") {
    return api_get(`/collab/by-project?identity=${identityUuid}&project=${projectUuid}&cursor=${cursor}`)
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
        });
}

async function _fetchCollabsWith(identityKey: string, mututalIdentityKey: string, cursor = "") {
    return api_get(`/collab/with-mutual?identity=${identityKey}&mutual_identity=${mututalIdentityKey}&cursor=${cursor}`)
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
        });
}

async function _getCollab(identityKey: string, collab: string) {
    return api_get(`/collab/?identity=${identityKey}&collab=${collab}`)
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
        });
}


async function _getCollabsByKeyList(identityKey: string, collab: string[]) {
    const collab_list = collab.join(',');
    return api_get(`/collab/list-by-keys?identity=${identityKey}&collab_list=${collab_list}`)
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
        });
}


async function _collabInviteCreate(collab: string, identityKey: string) {
    const props = Object({
        associated_type: 'collab',
        associated_uuid: collab,
        identity: identityKey
    });

    return api_post('/collab/invite/create', props)
        .then(async (res) => {
            if(res.ok) {
                return await res.json();
            }
            else {
                throw await res.json();
            }
        }).
        catch((err) => {
            throw err;
        });
}


async function _collabInviteMutual(soi="", collab="", mutualIdentityKey="") {
    const props = {
        collab: collab,
        identity: soi,
        mutual_identity: mutualIdentityKey
    };

    return api_post('/collab/invite/mutual', props)
        .then(async (res) => {
            if(res.ok) {
                return await res.json();
            }
            else {
                throw await res.json();
            }
        });
}


async function _collabDedicatedInviteDayOne(collab="", identityKey="") {
    const props = { collab: collab,
        assistant_identity: identityKey };
    return api_post('/collab/invite/dedicated-invite-dayone', props)
        .then(async (res) => {
            if(res.ok) {
                return await res.json();
            }
            else {
                throw await res.json();
            }
        });
}

async function _collabInviteDedicated(collab="", identityKey="") {
    const props = { collab: collab,
        identity: identityKey };
    return api_post('/collab/invite/dedicated', props)
        .then(async (res) => {
            if(res.ok) {
                return await res.json();
            }
            else {
                throw await res.json();
            }
        });
}

async function _collabInviteSupport(collab="", identityKey="") {
    const props = { collab: collab,
        identity: identityKey };
    return api_post('/collab/invite/support', props)
        .then(async (res) => {
            if(res.ok) {
                return await res.json();
            }
            else {
                throw await res.json();
            }
        });
}





async function _collabInviteMutualList(identityKey = "", cursor = "") {
    return api_get("/collab/invite/mutual/list", {identity: identityKey, cursor: cursor})
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
        });
}


async function _collabInviteList(collab = "", cursor = "") {
    return api_get(`/collab/invite/list?collab=${collab}&cursor=${cursor}`)
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
        });
}

async function _collabInviteAvailableList(workKey: string, cursor = "") {
    const params = { identity: workKey, cursor };
    return api_get("/collab/invite/available/list", params)
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
        });
}

async function _collabInviteAcceptedList(cursor = "") {
    return api_get(`/collab/invite/accepted/list?cursor=${cursor}`)
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
        });
}

async function _collabInviteGet(workKey: string, invite: string) {
    const params = { identity: workKey, invite };
    return api_get("/collab/invite", params)
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
            else {
                console.error("error fetching invite", res);
                return null;
            }
        });
}

async function _collabAcceptInvite(invite: string, identity: string) {
    const data = { invite, identity };
    return api_post('/collab/invite/accept', data)
        .then(async (res) => {
            if(res.ok) {
                return await res.json();
            }
        });
}

async function _collabWithdrawInvite(invite:string, collab: string, identityKey: string) {
    const data = { invite: invite, collab: collab, identity: identityKey };
    return api_post('/collab/invite/withdraw', data)
        .then(async (res) => {
            if(res.ok) {
                return await res.json();
            }
        });
}



export default ProjectAPI;
